<p>Add the details of a person you would like to nominate to look after these things for you.</p>
<hr />
<app-master-form [object]="object" [key]="key" [extraData]="extraData"></app-master-form >
